/**
 * Aux component that is used to wrap our components to avoid unnecessary divs
 * @param children
 * @returns {*}
 */

export default ({ children }) => children;
